import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
const Response = z.object({
    hasPassword: z.boolean(),
});
export const url = () => environment() === "PROD"
    ? "https://middleware.prod.farther.com/identity/authentication/email/password/check"
    : "https://middleware.uat.farther.com/identity/authentication/email/password/check";
export const checkForExistingPassword = async (email) => {
    const res = await axios.post(url(), { email, createUser: true }, {
        headers: {
            Version: "20240529",
            Authorization: `Bearer none`,
            "idempotency-key": `${new Date().toISOString()}-${email}`,
        },
        validateStatus: (status) => {
            return status < 500;
        },
    });
    // Expect 200 & 201
    if (res.status > 202) {
        return "NoPassword";
    }
    const decoded = Response.safeParse(res.data);
    if (decoded.success) {
        return decoded.data.hasPassword ? "HasPassword" : "NoPassword";
    }
    else {
        const errorMessage = `[checkForExistingPassword] Could not parse`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
export default checkForExistingPassword;
//# sourceMappingURL=checkForExistingPassword.js.map